import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { NgxIndexedDB } from 'ngx-indexed-db';
import { TokenService } from './token.service';
import {
    catchError,
    forkJoin,
    Observable,
    of,
    switchMap,
    throwError,
} from 'rxjs';
import { UserService } from 'app/core/user/user.service';
import { Store } from '@ngrx/store';
import { LogOut, ResetStore } from '../store/actions/auth.actions';
@Injectable({
    providedIn: 'root',
})
export class AuthService {
    private db: NgxIndexedDB;
    private _authenticated: boolean = false;
    /**
     * @description           Constructor de clase
     * @param httpClient      Módulo que permite las peticiones http del cliente
     */
    constructor(
        private httpClient: HttpClient,
        protected tokenService: TokenService,
        private _userService: UserService,
        private store: Store
    ) {
        // this.db = new NgxIndexedDB(environment.nombreAplicacion, 1);
    }

    /**
     * @description     Método para obtención de Token Seguridad V2
     * @returns         Observable
     */
    GetToken() {
        return new Observable<boolean>((observer) => {
            this.db.openDatabase(1).then(() => {
                this.db
                    .getAll('seguridad')
                    .then((res) => {
                        if (res.length > 0) {
                            observer.next(true);
                            observer.complete();
                        } else {
                            observer.next(false);
                            observer.complete();
                        }
                    })
                    .catch(() => {
                        observer.next(false);
                        observer.complete();
                    });
            });
        });
    }

    GetTokenStr(): string {
        return this.tokenService.getToken();
    }
    /**
     * Setter & getter for access token
     */
    set accessToken(token: string) {
        localStorage.setItem('accessToken', token);
    }

    get accessToken(): string {
        return localStorage.getItem('accessToken') ?? '';
    }
    /**
     * Método para verificar si el usuario está autenticado
     * @returns {boolean} True si está autenticado, false de lo contrario
     */
    isAuthenticated(): boolean {
        return this._authenticated;
    }
    /**
     * @description         Método para registrar usuario
     * { @param user          Nombre de usuario
     * @param pass          Password de usuario
     * @param email         email de usuario
     * @param rfc          	rfc de usuario
     * @param razonSocial   razonSocial de usuario  }
     * @returns             Observable
     */
    signUp(body: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json', // Establece el tipo de contenido JSON
        });
        return this.httpClient.post(
            environment.serviceUrl + 'ope-cuentas/register',
            body,
            { headers }
        );
    }

    /**
     * @description         Método para realizar login del usuario
     * { @param user        Nombre de usuario
     * @param pass          Password de usuario
     * @returns             Observable
     */
    login(body: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json', // Establece el tipo de contenido JSON
        });
        return this.httpClient.post(
            environment.serviceUrl + 'auth/local',
            body,
            { headers }
        );
    }
    /**
     * @description         Método para obtener info del usuario
     * @returns             Observable
     */
    infoLogin(userId, email): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json', // Establece el tipo de contenido JSON
        });

        const userInfo = this.httpClient.get(
            environment.serviceUrl +
            'users/me?fields[0]=id&fields[1]=username&fields[2]=email&fields[3]=blocked&fields[4]=name&fields[5]=cellphone&populate[cnf_rol_modulo][populate][cnf_modulos][populate]=cnf_modulo',
            { headers }
        );

        const otraPeticion = this.httpClient.get(
            environment.serviceUrl +
            `ope-empresas?filters[users_permissions_users][id]=${userId}&populate=logo,ope_empresa_estatus_hs.ope_empresa_estatus&sort=createdAt:ASC`,
            { headers }
        );

        // Tercera petición para obtener las cuentas asociadas al usuario por ID
        const opeCuentaRequest = this.httpClient.get(
            environment.serviceUrl +
            `ope-cuentas?filters[correo][$eq]=${email}`,
            { headers }
        );

        return forkJoin([userInfo, otraPeticion, opeCuentaRequest]);
    }
    /**
     * Sign in
     *
     * @param credentials
     */
    signIn(credentials: { identifier: any; password: any }): Observable<any> {
        console.log('sign in ');
        const headers = new HttpHeaders({
            'Content-Type': 'application/json', // Establece el tipo de contenido JSON
        });
        // Throw error, if the user is already logged in
        if (this._authenticated) {
            return throwError('User is already logged in.');
        }
        try {
            return this.httpClient
                .post(environment.serviceUrl + 'auth/local', credentials, {
                    headers,
                })
                .pipe(
                    switchMap((response: any) => {
                        this.accessToken = response.jwt;
                        this._authenticated = true;
                        return of(response);
                    })
                );
        } catch (error) {
            console.log(error)
        }
    }
    /**
     * Sign out
     */
    signOut(): Observable<any> {
        localStorage.clear(); // Limpia el almacenamiento local
        this._authenticated = false;
        
        this.store.dispatch(LogOut()); // Limpia el auth state
        this.store.dispatch(ResetStore()); // Limpia todo el store si es necesario

        location.reload(); // Refresca la aplicación

        return of(true);
    }
}
